"use strict";

exports.__esModule = true;
exports.Animation = exports.animationPlayStateKeys = void 0;

var _reactHooks = require("@okee-uikit/react-hooks");

var _util = require("../util");

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var animationPlayStateKeys = (0, _reactHooks.getPrefixedStyleKey)('animationPlayState');
exports.animationPlayStateKeys = animationPlayStateKeys;

var Animation = function (_Emitter) {
  _inheritsLoose(Animation, _Emitter);

  function Animation() {
    var _this;

    _this = _Emitter.apply(this, arguments) || this;
    _this.type = 'animation';
    _this.ele = null;
    _this.timeout = true;
    _this.maxTimeCost = Infinity;
    return _this;
  }

  var _proto = Animation.prototype;

  _proto.updateOptions = function updateOptions(options) {
    var _a, _b;

    this.activeClassName = options.activeClassName;
    this.presetClassName = options.presetClassName;
    this.validKeyframes = options.validKeyframes;
    this.validProperty = options.validProperty;
    this.validTarget = options.validTarget;
    this.timeout = (_a = options.timeout) !== null && _a !== void 0 ? _a : true;
    this.type = (_b = options.type) !== null && _b !== void 0 ? _b : 'animation';
  };

  _proto.setEle = function setEle(ele) {
    this.ele = ele;
  };

  _proto.start = function start(identifier) {
    if (!this.ele) {
      return function () {
        return void 0;
      };
    }

    var removeEffect = this.type === 'animation' ? this.startAnimation(this.ele, identifier) : this.startTransition(this.ele, identifier);
    return removeEffect;
  };

  _proto.setAnimationPlayState = function setAnimationPlayState(paused) {
    if (!this.ele) {
      return;
    }

    if (paused) {
      for (var _iterator = _createForOfIteratorHelperLoose(animationPlayStateKeys), _step; !(_step = _iterator()).done;) {
        var styleKey = _step.value;
        this.ele.style[styleKey] = 'paused';
      }
    } else {
      for (var _iterator2 = _createForOfIteratorHelperLoose(animationPlayStateKeys), _step2; !(_step2 = _iterator2()).done;) {
        var _styleKey = _step2.value;
        this.ele.style[_styleKey] = '';
      }
    }
  };

  _proto.startAnimation = function startAnimation(ele, identifier) {
    var _this2 = this;

    var validTarget = this.validTarget;
    var validKeyframes = this.validKeyframes;
    var activeClassName = this.activeClassName || '';
    var presetClassName = this.presetClassName || '';
    var meta = {
      animating: true,
      reseted: false,
      timeoutId: null
    };
    var timeSource = validTarget && validTarget instanceof HTMLElement ? validTarget : ele;
    this.setAnimationPlayState(true);
    (0, _reactHooks.addClass)(ele, presetClassName + " " + activeClassName);
    var animationRange = this.getTimeRange((0, _util.getAnimationValues)(timeSource));

    var handler = function handler(event) {
      if (validTarget !== undefined && validTarget !== event.target) {
        return;
      }

      if (!meta.animating || meta.reseted) {
        return;
      }

      if (isValidKeyframe(validKeyframes, animationRange, event)) {
        _util.AnimateEvents.removeAnimationEndListener(ele, handler);

        (0, _reactHooks.removeClass)(ele, presetClassName + " " + activeClassName);
        meta.timeoutId && clearTimeout(meta.timeoutId);
        Object.assign(meta, {
          animating: false,
          reseted: true,
          timeoutId: null
        });

        _this2.emit('animate-end', identifier, false);
      }
    };

    _util.AnimateEvents.addAnimationEndListener(ele, handler);

    this.emit('animate-ready', identifier);
    this.setAnimationPlayState(false);
    this.emit('animate-start', identifier);

    var reset = function reset() {
      if (!meta.reseted) {
        _util.AnimateEvents.removeAnimationEndListener(ele, handler);

        (0, _reactHooks.removeClass)(ele, presetClassName + " " + activeClassName);
        meta.timeoutId && clearTimeout(meta.timeoutId);
        Object.assign(meta, {
          reseted: true,
          timeoutId: null
        });

        _this2.emit('animate-end', identifier, meta.animating);
      }
    };

    if (this.timeout !== false) {
      var timeout = this.timeout !== true ? this.timeout : this.maxTimeCost * 1000 + 300;
      meta.timeoutId = window.setTimeout(reset, timeout);
    }

    return reset;
  };

  _proto.startTransition = function startTransition(ele, identifier) {
    var _this3 = this;

    var validTarget = this.validTarget;
    var validProperty = this.validProperty;
    var activeClassName = this.activeClassName || '';
    var presetClassName = this.presetClassName || '';
    var meta = {
      animating: true,
      reseted: false,
      timeoutId: null
    };
    var timeSource = validTarget && validTarget instanceof HTMLElement ? validTarget : ele;
    (0, _reactHooks.addClass)(ele, presetClassName);
    var transitionRange = this.getTimeRange((0, _util.getTransitionValues)(timeSource));

    var handler = function handler(event) {
      if (validTarget !== undefined && validTarget !== event.target) {
        return;
      }

      if (!meta.animating || meta.reseted) {
        return;
      }

      if (isValidProperty(validProperty, transitionRange, event)) {
        _util.AnimateEvents.removeTransitionEndListener(ele, handler);

        (0, _reactHooks.removeClass)(ele, presetClassName + " " + activeClassName);
        meta.timeoutId && clearTimeout(meta.timeoutId);
        Object.assign(meta, {
          animating: false,
          reseted: true,
          timeoutId: null
        });

        _this3.emit('animate-end', identifier, false);
      }
    };

    _util.AnimateEvents.addTransitionEndListener(ele, handler);

    this.emit('animate-ready', identifier);
    (0, _reactHooks.addClass)(ele, activeClassName);
    this.emit('animate-start', identifier);

    var reset = function reset() {
      if (!meta.reseted) {
        _util.AnimateEvents.removeTransitionEndListener(ele, handler);

        (0, _reactHooks.removeClass)(ele, presetClassName + " " + activeClassName);
        meta.timeoutId && clearTimeout(meta.timeoutId);
        Object.assign(meta, {
          reseted: true,
          timeoutId: null
        });

        _this3.emit('animate-end', identifier, meta.animating);
      }
    };

    if (this.timeout !== false) {
      var timeout = this.timeout !== true ? this.timeout : this.maxTimeCost * 1000 + 300;
      meta.timeoutId = window.setTimeout(reset, timeout);
    }

    return reset;
  };

  _proto.getTimeRange = function getTimeRange(values) {
    var _this4 = this;

    this.maxTimeCost = Infinity;
    return values.reduce(function (prev, curr) {
      var currTimeCost = _this4.getTimeCost(curr);

      if (!prev) {
        _this4.maxTimeCost = currTimeCost;
        return [curr, curr];
      }

      if (_this4.getTimeCost(prev[0]) > currTimeCost) {
        prev[0] = curr;
      } else if (_this4.getTimeCost(prev[1]) < currTimeCost) {
        prev[1] = curr;
        _this4.maxTimeCost = currTimeCost;
      }
    }, undefined);
  };

  _proto.getTimeCost = function getTimeCost(value) {
    var times = 'iterationCount' in value ? value.iterationCount : 1;
    return value.delay + value.duration * times;
  };

  return Animation;
}(_reactHooks.Emitter);

exports.Animation = Animation;

function isValidKeyframe(option, valueRange, event) {
  if (option === void 0) {
    option = false;
  }

  switch (typeof option) {
    case 'function':
      return option(event.animationName, event);

    case 'string':
      return event.animationName === option;
  }

  if (!valueRange) {
    return false;
  }

  return option ? event.animationName === valueRange[0].keyframes : event.animationName === valueRange[1].keyframes;
}

function isValidProperty(option, valueRange, event) {
  if (option === void 0) {
    option = false;
  }

  switch (typeof option) {
    case 'function':
      return option(event.propertyName, event);

    case 'string':
      return event.propertyName === option;
  }

  if (!valueRange) {
    return false;
  }

  return option ? event.propertyName === valueRange[0].property : event.propertyName === valueRange[1].property;
}